// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"My-z","giftOrPromoSelector":"Ny-z","disabled":"Oy-z","subTitle":"Py-z","selectShipAddressMessage":"Qy-z","changePayment":"Ry-z"};